import { Helmet } from 'react-helmet-async';

import Button from '../../Components/Button';
import Footer from '../../Components/Footer';
import MediaBrowser from '../../Components/Main pages/Media';
import Navbar from '../../Components/Navbar';
import SearchSidebar from '../../Components/Search bars/Treesearch';
import Landingpage from '../Home/Landingpage';

import styles from './Productionpage.module.css';

export default function Products() {
  const siteUrl = 'https://nasrollah.info'; 
  const pageUrl = `${siteUrl}/productions`;  

  const pageTitle = 'تولیدات و آثار رسانه‌ای شهيد سيد حسن نصرالله |  nasrollah.info';
  const pageDescription =
    'مشاهده آثار، تولیدات رسانه‌ای سايت نصرالله اينفو.';

  const pageImage = `${siteUrl}/assets/images/og-products.jpg`;

  const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebPage',
        '@id': `${pageUrl}#webpage`,
        url: pageUrl,
        name: pageTitle,
        description: pageDescription,
        inLanguage: 'fa-IR',
        isPartOf: {
          '@type': 'WebSite',
          '@id': `${siteUrl}#website`,
          url: siteUrl,
          name: 'nasrollah.info',
          inLanguage: 'fa-IR',
        },
        breadcrumb: {
          '@id': `${pageUrl}#breadcrumb`,
        },
      },
      {
        '@type': 'CollectionPage',
        '@id': `${pageUrl}#collection`,
        url: pageUrl,
        name: 'تولیدات و آثار رسانه‌ای',
        description: pageDescription,
        inLanguage: 'fa-IR',
      },
      {
        '@type': 'BreadcrumbList',
        '@id': `${pageUrl}#breadcrumb`,
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'صفحه اصلی',
            item: siteUrl,
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: 'تولیدات',
            item: pageUrl,
          },
        ],
      },
    ],
  };

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta httpEquiv="content-language" content="fa-IR" />
        <meta name="author" content="نصرالله اينفو" />
        <link rel="canonical" href={pageUrl} />

        <meta property="og:type" content="website" />
        <meta property="og:locale" content="fa_IR" />
        <meta property="og:site_name" content="nasrollah.info" />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={pageImage} />
        <meta property="og:image:alt" content="تولیدات و آثار رسانه‌ای" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={pageImage} />

        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
    <Navbar />
    <Landingpage />

    <div className={styles.main}>
        <div className={styles.container}>
            <div className={styles.section}>
  <span className={styles.sectionSubtitle}>
    'آثار و تولیدات رسانهای'
  </span>
  <h1 className={styles.sectionTitle}>
    'توليدات'
  </h1>
</div>
            <p className={styles.para}>در این بخش، مجموعه‌ای از محصولات صوتی و تصویری برگزیده از سخنرانی‌های شهيد سيد حسن نصرالله گردآوری و عرضه شده است. این محصولات شامل کلیپ‌های کوتاه و گزینش‌شده‌ای از بیانات ایشان است که در قالب ویدیوهایی با روایت صدای خود ایشان تهیه و تدوین شده‌اند. هر یک از این کلیپ‌ها، لحظاتی ناب و تأثیرگذار از اندیشه‌ها و رهنمودهای ایشان را در حوزه‌های سیاست، دین، عرفان و مباحث اندیشه‌ای در بر می‌گیرد و برای استفاده در فضای مجازی، پژوهش و یا بازنشر فرهنگی مناسب است. این مجموعه، تلاشی است برای حفظ و نشر میراث گران‌بهای فکری ایشان در قالبی کوتاه و جذاب</p>
            <Button />
        </div>
    </div>

    <div className={styles.container} >
        <div className={styles.bodyContent}>
            <SearchSidebar />

            <MediaBrowser />
        </div>
    </div>
    
    <Footer />
    </>);
}